import {Component, ElementRef, Input, OnChanges, OnDestroy, OnInit} from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { CesiumMapService } from '../service/map-viewer.service';
import { XsApplicationEventsService } from '../xs/services/events/application-events.service';
import { BaseComponent } from './BaseComponent';
import { Constants } from './Constants';

const Cesium = (<any>window).Cesium

// the slider is used for image comparing (slide between two image layers)

@Component({
  selector: 'map-viewer',
  template: `
    <div class="map-viewer"> 
      <div hidden id="slider1"></div>
      <div class="cesium-map" style="width:100%;height:100%;"></div>
    </div>`
})

export class MapViewerComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  debug:boolean = Constants.debug_off;
  debugPrimary:string = Constants._orange;
  debugSecondary:string = Constants._white;

  canvas:HTMLElement = null;

  uuid:string = this.__uuidv4();

  @Input()
  name:string = 'base';
  
  // the canvas is a native wrapper around us
  constructor( 
    public router: Router, public snackBar: MatSnackBar, public dialog: MatDialog,
    public applicationEvents:XsApplicationEventsService, public me: ElementRef, public cesiumMap: CesiumMapService 
  ) {
    super(router, snackBar, dialog);

    this.canvas = me.nativeElement;

    if ( this.debug ) { console.log ( '%c map-viewer-component %c CONSTRUCTOR ', this.debugPrimary, this.debugSecondary, me, this.canvas ); }
    
  }

  ngOnChanges() { }

  init() {

    if ( this.debug ) { console.log ( '%c map-viewer-component %c init() ', this.debugPrimary, this.debugSecondary ); }

    // pass in the canvas, and Cesium will inject itself into it
    this.cesiumMap.init( this.name, this.canvas );
  }

  destroy() {
    if ( this.debug ) { console.log ( '%c map-viewer-component %c destroy() ', this.debugPrimary, this.debugSecondary ); }
    this.cesiumMap.destroy( this.name );
  }

  __uuidv4( token:string = '-', prefix:string = '') {
    return ( prefix + 'xxxxxxxx'+token+'xxxx'+token+'4xxx'+token+'yxxx'+token+'xxxxxxxxxxxx').replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
  }

}
